const PROPERTY_DEFAULT_VALUE = {
	COLOR: '#000000',
	FILLTRANS: 100,
	STROKE_DASH_ARRAY: '0',
	FILL_OPACITY: 100,
	TEXTBOX_DIRECTION: 0,
	HTML_URL: 'http://',
	ZOOM_LEVEL_MIN_POSITION: 0,
	ZOOM_LEVEL_MAX_POSITION: 22,
	IMAGE_SIZE: 1
};

const MARKER_GRAPH_TYPE = {
	MARKER: 1,
	BUBBLE: 2,
	AREA: 3,
	DENSITY: 4
};

const MARKER_SHAPE = {
	PINS: 1,
	SQUARES: 2,
	DIAMONDS: 3,
	IMAGES: 4,
	CIRCLES: 5
};

const SHOW_DATA_LABEL = {
	NONE: 0,
	TEXT: 1,
	VALUE: 2,
	TEXT_AND_VALUE: 3
};

const MARKER_CLUSTERING = {
	ON: '2',
	OFF: '3',
	PIE: '4'
};

const ZOOM_BEHAVIOR = {
	STATIC: '0',
	DYNAMIC: '1'
};

const BORDER_STYLE = {
	SOLID: '0',
	DASH: '6, 2',
	DOTTED: '2, 2'
};

export {
	PROPERTY_DEFAULT_VALUE,
	MARKER_GRAPH_TYPE,
	MARKER_SHAPE,
	SHOW_DATA_LABEL,
	MARKER_CLUSTERING,
	ZOOM_BEHAVIOR,
	BORDER_STYLE
};
